import React from 'react';

const FooterCopyright = ({ className }) => {
  return (
    <div className={`footer-copy ${className}`}>
      © {new Date().getFullYear()} PayOnDelivery Inc.
    </div>
  )
};

export default FooterCopyright;
